export enum NetworkId {
    MAINNET = 1,
    TESTNET_GOERLI = 5,
  
    ARBITRUM = 42161,
    ARBITRUM_TESTNET = 421613,
  
    AVALANCHE = 43114,
    AVALANCHE_TESTNET = 43113,
  
    POLYGON = 137,
    POLYGON_TESTNET = 80001,
  
    FANTOM = 250,
    FANTOM_TESTNET = 4002,
  
    OPTIMISM = 10,
    OPTIMISM_TESTNET = 69,
  
    BOBA = 288,
    BOBA_TESTNET = 28,

    LOCAL = 31337,

    BLOCK_POT_TESTNET = 69696
  }
  
export type EthereumNetwork = NetworkId.MAINNET | NetworkId.TESTNET_GOERLI;